import React from "react";
import { IRecordResponse } from "app/api/types";

import "./styles.scss";

interface IProps {
  recordId: IRecordResponse["id"];
  type: CellTypes;
  timeStartIndex: number;
  onClick: (id: number) => void;
}

export enum CellTypes {
  CREATED = "created",
  ACCEPTED = "accepted",
  EMPTY = "empty"
}

const Cell: React.FC<IProps> = props => {
  return (
    <div
      className={`record-cell record-cell_${props.type}`}
      onClick={() =>
        props.recordId !== -1
          ? props.onClick(props.recordId)
          : props.onClick(props.timeStartIndex)
      }
    ></div>
  );
};

export default Cell;
